import * as React from "react";
function SvgCameraOn(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.44 10.978L20 9.756v4.1L17.311 13l-.622 1.85 4 1.273L22 15.198V8.195l-1.44-.873-4 1.91.88 1.746zM3 6.347c-.552 0-1 .435-1 .972v8.754c0 .538.448.973 1 .973h13v-10.7H3zM4 15.1V8.29h10v6.81H4z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCameraOn);
export default ForwardRef;
